import { render, staticRenderFns } from "./run-detail.vue?vue&type=template&id=10d02ec3&scoped=true&"
import script from "./run-detail.vue?vue&type=script&lang=ts&"
export * from "./run-detail.vue?vue&type=script&lang=ts&"
import style0 from "./run-detail.vue?vue&type=style&index=0&id=10d02ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d02ec3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
